import React from "react";
import ReactMarkdown from 'react-markdown';

interface ResultProps {
  totalScore: number;
  classification: string | undefined;
  answers: any[];
  onReset: () => void;
}

const Result: React.FC<ResultProps> = ({
  totalScore,
  classification,
  answers,
  onReset,
}) => {
  return (
    <div className="result">
      <h2>
        Total Score: {totalScore} - {classification}
      </h2>
      <div className="answers">
        {answers.map((answer, index) => (
          <div key={index} className="answer-item">
            <p className="question-text"><ReactMarkdown>{answer.question}</ReactMarkdown></p>
            <p className="answer-text">
              Answer: {answer.answer ? "Yes" : "No"}
            </p>
          </div>
        ))}
      </div>
      <button onClick={onReset}>Reset</button>
    </div>
  );
};

export default Result;